import LocationOnIcon from '@mui/icons-material/LocationOn';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import StarIcon from '@mui/icons-material/Star';
import { ProductListResponse } from '../../api/requests/interfaces/Product';
import { format, isBefore, isEqual } from 'date-fns';
import { useNavigate } from 'react-router-dom';
import { FavoriteButton } from './FavoriteButton';
import { useAppSelector } from '../../store/hooks';
import crownIcon from '../../assets/images/crown.png';

export interface ListingCardProps {
    data: ProductListResponse
}

export const ListingCard: React.FC<ListingCardProps> = (props) => {
    const navigate = useNavigate();

    const user = useAppSelector(state => state.auth.user);


    const getFirstAvailableDate = (availableDate: Date) => {
        if (isBefore(new Date(availableDate), new Date()) || isEqual(new Date(availableDate), new Date())) {
            return "tänasest"
        }
        return format(availableDate, "dd.MM")
    }

    const handleItemClick = () => {
        navigate('/detail/' + props.data.id, { preventScrollReset: false })
    }

    const formatLongDescription = (description: string) => {
        const allowedLen = 70;
        if (description.length >= allowedLen) {
            return description.slice(0, allowedLen) + " ...";
        }
        return description
    }

    const formatLongTitle = (title: string) => {
        const allowedLen = 60;
        if (title.length >= allowedLen) {
            return title.slice(0, allowedLen) + " ...";
        }
        return title
    }

    return (
        <div className="group w-full flex flex-row gap-3 items-start hover:shadow-main border-[1px] border-solid border-primary/20 rounded-xl transition-all duration-100 cursor-pointer 
        relative h-fit" onClick={handleItemClick}>
            <div className="relative basis-2/5 w-full cursor-pointer aspect-square">
                <img src={props.data.defaultPictureUrl} className={`${props.data.isHighlighted ? "" : ""} object-cover w-full h-full rounded-xl`} alt="W3Schools.com" />
                {user?.id !== props.data.userId &&
                    <div className="absolute top-2 left-2">
                        <FavoriteButton initialValue={false /* TODO: check if is user favorite */} productId={props.data.id}/>
                    </div>
                }
            </div>
            <div className="flex flex-col gap-2 basis-3/5 justify-start pt-2">
                <div className="font-medium text-start text-[20px] leading-5 cursor-pointer flex flex-row items-center">{formatLongTitle(props.data.title)}
                    {props.data.isHighlighted && <img src={crownIcon} className='w-[16px] h-[16px] ml-2'/>}</div>
                {/* <div className="flex flex-row gap-1 items-center group">
                    <div className="flex cursor-pointer">
                        <StarIcon style={{ color: "#edb157", height: "14px", width: "14px" }}/>
                        <StarIcon style={{ color: "#edb157", height: "14px", width: "14px" }} />
                        <StarIcon style={{ color: "#edb157", height: "14px", width: "14px" }} />
                        <StarIcon style={{ color: "#edb157", height: "14px", width: "14px" }} />
                        <StarIcon style={{ color: "#edb157", height: "14px", width: "14px" }} />
                    </div>
                    <div className="text-[12px] font-semibold text-neutral-600 cursor-pointer group-hover:text-primary">
                        4.5
                    </div>
                </div> */}
                <div className="flex flex-row gap-3">
                    <div className='flex gap-1 text-sm items-center font-semibold'>
                        <LocationOnIcon className="text-primary" />
                        {props.data.location.charAt(0).toUpperCase() + props.data.location.slice(1)}
                    </div>
                    <div className='flex gap-1 text-sm items-center font-semibold'>
                        <CalendarMonthIcon className="text-primary" />
                        Saadaval: {getFirstAvailableDate(props.data.firstAvailableDate ? props.data.firstAvailableDate : new Date())}

                    </div>

                </div>
                <div className="flex flex-row text-start items-baseline text-sm">
                    <span className="text-xl lg:text-2xl font-medium">{props.data.dailyPrice}</span> €/päev
                </div>
                <div className="font-light text-start text-sm cursor-pointer">{formatLongDescription(props.data.description)}</div>
            </div>
            {
                props.data.isHighlighted &&
                <div className='absolute left-1 md:left-2 bottom-2 p-1 text-xs bg-yellow-400 rounded-md shadow-sm'>Esiletõstetud</div>
            }
        </div>
    )
}